import {IContent} from "../../HubFramework"
import AllModules from "./Tabs/AllModules";
import ProjectInformation from "./Tabs/ProjectInformation";
import ProjectDocumentation from "./Tabs/ProjectDocumentation";
import {UserRoles} from "../../Utils";
import ProjectUserManagement from "./Tabs/UserManagement";
import {Logs} from "./Tabs/Logs";
import ProjectApiKeyManagement from "./Tabs/ApiKeyManagement";
import {odxIconSets} from "../../OdxComponents/constants";

/**
 * The content of the module
 * This is mandatory for every module. It contains all the information about the module.
 */
export const moduleContent: IContent = {
    moduleName: "ProjectContent",
    title: "Project",
    pages: [
        {
            displayName: "My Modules",
            contentPage: AllModules,
            icon: {
                name: "variants",
                iconSet: odxIconSets.core
            },
        },
        {
            displayName: "Users & Permissions",
            contentPage: ProjectUserManagement,
            icon: {
                name: "user-administration",
                iconSet: odxIconSets.core
            },
        },
        {
            displayName: "API Keys",
            contentPage: ProjectApiKeyManagement,
            minimumRole: UserRoles.admin,
            icon: {
                name: "lock",
                iconSet: odxIconSets.core
            },
        },
        {
            displayName: "Project Information",
            contentPage: ProjectInformation,
            icon: {
                name: "document-settings",
                iconSet: odxIconSets.core
            },
        },
        {
            displayName: "Help",
            contentPage: ProjectDocumentation,
            icon: {
                name: "help",
                iconSet: odxIconSets.core
            },
        }
    ],
    defaultPage: "My Modules",
};
